import { Injectable } from '@angular/core';
import { PaymentItem } from '../payment-item/payment-item.model';


@Injectable()
export class PaymentUtilService {

    readonly MAX_PAYMENT_ITEMS = 50;

    public calculateTotalAmount(paymentItems: PaymentItem[]): number {
        let paymentItemsTotalAmount = 0;
        paymentItems.forEach((paymentItem) => {
            paymentItemsTotalAmount += paymentItem.amount;
        });

        return paymentItemsTotalAmount;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/payment/payment.util.service.ts